!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("styled-components"), require("@material-ui/core/Checkbox"), require("@material-ui/core/FormControlLabel"), require("moment/moment"), require("react-day-picker/DayPickerInput"), require("@material-ui/core/TextField"), require("react-select"), require("@fortawesome/react-fontawesome"), require("@material-ui/core/Radio"), require("@material-ui/core/RadioGroup"), require("react-table"), require("lodash"), require("moment"), require("uuid"), require("prop-types")) : "function" == typeof define && define.amd ? define(["exports", "react", "styled-components", "@material-ui/core/Checkbox", "@material-ui/core/FormControlLabel", "moment/moment", "react-day-picker/DayPickerInput", "@material-ui/core/TextField", "react-select", "@fortawesome/react-fontawesome", "@material-ui/core/Radio", "@material-ui/core/RadioGroup", "react-table", "lodash", "moment", "uuid", "prop-types"], t) : t((e = e || self)["ipc-components"] = {}, e.React, e.styled, e.MUICheckbox, e.FormControlLabel, e.moment, e.DayPickerInput, e.TextField, e.Select$1, e.reactFontawesome, e.Radio, e.RadioGroup, e.ReactTable, e._, e.moment$1, e.uuid, e.PropTypes);
}(this, function (e, t, r, n, o, i, a, l, u, c, s, d, p, f, m, h, b) {
  "use strict";

  var g = "default" in t ? t.default : t,
      v = "default" in r ? r.default : r;

  function y(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }

  n = n && n.hasOwnProperty("default") ? n.default : n, o = o && o.hasOwnProperty("default") ? o.default : o, i = i && i.hasOwnProperty("default") ? i.default : i, a = a && a.hasOwnProperty("default") ? a.default : a, l = l && l.hasOwnProperty("default") ? l.default : l, u = u && u.hasOwnProperty("default") ? u.default : u, s = s && s.hasOwnProperty("default") ? s.default : s, d = d && d.hasOwnProperty("default") ? d.default : d, p = p && p.hasOwnProperty("default") ? p.default : p, f = f && f.hasOwnProperty("default") ? f.default : f, m = m && m.hasOwnProperty("default") ? m.default : m, h = h && h.hasOwnProperty("default") ? h.default : h, b = b && b.hasOwnProperty("default") ? b.default : b;
  var x = {
    primaryOne: "#073142",
    primaryTwo: "#2DBAB9",
    primaryThree: "#D20020",
    primaryFour: "#0099CE",
    primaryFive: "#5BA13C",
    secondaryOne: "#7DBD7B",
    secondaryTwo: "#EE696D",
    secondaryThree: "#496682",
    secondaryFour: "#E9F0F5",
    tableHighlight: "#FFECD5",
    greyOne: "#89949B",
    greyTwo: "#575858",
    greyThree: "#DDD",
    greyFour: "#6A6B6B",
    greyFive: "#EDEDED",
    greySix: "#96A7AD",
    greySeven: "#CED6DE",
    white: "#FFF"
  },
      O = x.primaryOne,
      w = x.greySeven,
      E = r.css(["border-style:solid;border-width:0;"]),
      k = r.css(["font-family:Lato,sans-serif;padding:5px 18px 7px 18px;font-size:15px;border-radius:15px;min-height:30px;"]),
      A = r.css(["", ";color:", ";border-color:transparent;background-color:", ";cursor:pointer;"], k, O, w),
      S = r.css(["", ";color:darkgrey;background-color:lightgray;border-color:darkgrey;cursor:default;"], k);
  var j = r.css(["", ""], function (e) {
    return t = function (e) {
      return e.theme && e.theme.button ? e.theme.button : e.disabled ? S : A;
    }(e), r.css(["", " ", ""], E, t);
    var t;
  });

  function N() {
    var e = y(["", ""]);
    return N = function N() {
      return e;
    }, e;
  }

  var C = v.button(N(), j),
      P = function P(e) {
    return g.createElement(C, e);
  };

  function T(e, t) {
    if (null == e) return {};

    var r,
        n,
        o = function (e, t) {
      if (null == e) return {};
      var r,
          n,
          o = {},
          i = Object.keys(e);

      for (n = 0; n < i.length; n++) {
        r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (n = 0; n < i.length; n++) {
        r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }
    }

    return o;
  }

  var D = "\n  padding: 20px;\n  background: ".concat(x.greyFive, ";\n  border-radius: 10px;\n");

  function F() {
    var e = y(["", ""]);
    return F = function F() {
      return e;
    }, e;
  }

  var _ = v.div(F(), D);

  function R() {
    return (R = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var B = x.primaryFour,
      I = r.css(["margin:0 !important;.checkbox_root{padding:4px;margin-left:0 !important;}.checkbox_checked{color:", " !important;}"], B);

  function V() {
    var e = y(["", ""]);
    return V = function V() {
      return e;
    }, e;
  }

  var q = {
    root: "checkbox_root",
    checked: "checkbox_checked"
  },
      L = {
    label: "checkbox_label",
    root: "checkbox_wrapper"
  },
      z = function z(e) {
    var t = R({}, e);
    return g.createElement(n, Object.assign({
      classes: q
    }, t));
  },
      U = v(o)(V(), I);

  function W(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function H(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function M(e, t, r) {
    return t && H(e.prototype, t), r && H(e, r), e;
  }

  function Q(e) {
    return (Q = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function G(e) {
    return (G = "function" == typeof Symbol && "symbol" === Q(Symbol.iterator) ? function (e) {
      return Q(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : Q(e);
    })(e);
  }

  function Y(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function K(e, t) {
    return !t || "object" !== G(t) && "function" != typeof t ? Y(e) : t;
  }

  function J(e) {
    return (J = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function Z(e, t) {
    return (Z = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function X(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && Z(e, t);
  }

  function $(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  var ee = {
    date: "DD/MMM/YYYY",
    dateTime: "DD/MMM/YYYY HH:mm"
  },
      te = r.css([".DayPickerInput{display:block;margin-bottom:6px;input{width:100%;}}.DayPickerInput-OverlayWrapper{position:relative;.DayPickerInput-Overlay{left:0;z-index:1;position:absolute;background:white;box-shadow:0 2px 5px rgba(0,0,0,0.15);}.DayPicker{display:inline-block;&-wrapper{position:relative;user-select:none;padding-bottom:1rem;flex-direction:row;}&-Months{display:flex;flex-wrap:wrap;justify-content:center;}&-Month{display:table;border-collapse:collapse;border-spacing:0;user-select:none;margin:1rem 1rem 0;}&-NavButton{position:absolute;cursor:pointer;top:1rem;right:1.5rem;margin-top:2px;color:#8b9898;width:1.25rem;height:1.25rem;display:inline-block;background-size:50%;background-repeat:no-repeat;background-position:center;&:hover{opacity:0.8;}&--prev{margin-right:1.5rem;background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC');}&--next{background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==');}&--interactionDisabled{display:none;}}&-Caption{padding:0 0.5rem;display:table-caption;text-align:left;margin-bottom:0.5rem;& > div{font-size:1.15rem;font-weight:500;}}&-Weekdays{margin-top:1rem;display:table-header-group;}&-WeekdaysRow{display:table-row;}&-Weekday{display:table-cell;padding:0.5rem;font-size:0.875em;text-align:center;color:#8b9898;& abbr[title]{border-bottom:none;text-decoration:none;}}&-Body{display:table-row-group;}&-Week{display:table-row;}&-Day{display:table-cell;padding:0.5rem;text-align:center;cursor:pointer;vertical-align:middle;outline:none;}&-WeekNumber{display:table-cell;padding:0.5rem;text-align:right;vertical-align:middle;min-width:1rem;font-size:0.75em;cursor:pointer;color:#8b9898;border-right:1px solid #eaecec;}&--interactionDisabled .DayPicker-Day{cursor:default;}&-Footer{padding-top:0.5rem;}&-TodayButton{border:none;background-image:none;background-color:transparent;box-shadow:none;cursor:pointer;color:#4a90e2;font-size:0.875em;}&-Day{padding:9px;&--today{color:#d0021b;font-weight:700;}&--outside{cursor:default;color:#8b9898;}&--disabled{color:#dce0e0;cursor:default;}&--sunday{background-color:#f7f8f8;}}}}.DayPicker-Day--sunday:not(.DayPicker-Day--today){color:#dce0e0;}.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside){position:relative;color:#f0f8ff;background-color:#4a90e2;border-radius:100%;}.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover{background-color:#51a0fa;}.DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover{background-color:#f0f8ff;border-radius:50%;}"]);

  function re() {
    var e = y(["", ""]);
    return re = function re() {
      return e;
    }, e;
  }

  var ne = function ne(e) {
    var t = e.onChange,
        r = e.value;
    return function (e, n) {
      if (e) {
        var o = i(e);
        !n.selected && i(r).isSame(o, "day") ? t(e) : t(o.startOf("day").toDate());
      } else t(void 0);
    };
  },
      oe = v.div(re(), te),
      ie = function (e) {
    function t() {
      var e, r;
      W(this, t);

      for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++) {
        o[a] = arguments[a];
      }

      return $(Y(r = K(this, (e = J(t)).call.apply(e, [this].concat(o)))), "parseDate", function (e) {
        if (11 !== e.length && 17 !== e.length) return "";
        var t = i(e, ee[r.props.type]);
        return t.isValid() ? t.toDate() : "";
      }), $(Y(r), "formatDate", function (e) {
        return i(e).format(ee[r.props.type]);
      }), r;
    }

    return X(t, e), M(t, [{
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.value,
            r = e.type;
        return g.createElement(oe, null, g.createElement(a, Object.assign({
          value: t,
          onDayChange: ne(this.props),
          formatDate: this.formatDate,
          parseDate: this.parseDate,
          placeholder: ee[r]
        }, this.props)));
      }
    }]), t;
  }(t.Component),
      ae = x.greyThree,
      le = x.greyFour,
      ue = r.css(["border-style:solid;border-width:0;font-family:Lato,sans-serif;"]),
      ce = r.css(["border:2px solid ", ";border-radius:4px;color:", ";font-size:0.875rem;padding:4px 10px 5px 10px;"], ae, le),
      se = r.css(["", ";font-size:1rem;"], ce),
      de = r.css(["color:darkgrey;background-color:lightgray;border-color:darkgrey;"]);

  var pe = r.css(["", ""], function (e) {
    return t = function (e) {
      return e.theme && e.theme.input ? e.theme.input : e.disabled ? de : e.huge ? se : ce;
    }(e), r.css(["", " ", ""], ue, t);
    var t;
  });

  function fe() {
    var e = y(["", ""]);
    return fe = function fe() {
      return e;
    }, e;
  }

  var me = v.input(fe(), pe),
      he = function he(e) {
    return g.createElement(me, e);
  };

  function be() {
    var e = y(["\n  font-family: Lato, sans-serif;  \n"]);
    return be = function be() {
      return e;
    }, e;
  }

  he.defaultProps = {
    huge: !1,
    value: ""
  };
  var ge = v.label(be());

  function ve(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) {
        var r = [],
            n = !0,
            o = !1,
            i = void 0;

        try {
          for (var a, l = e[Symbol.iterator](); !(n = (a = l.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            n || null == l.return || l.return();
          } finally {
            if (o) throw i;
          }
        }

        return r;
      }
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  var ye = x.primaryFour,
      xe = "\n  color: ".concat(x.white, ";  \n  background-color: ").concat(ye, ";\n"),
      Oe = r.css(["width:auto;font-size:12px;padding-left:28px !important;padding-right:28px !important;font-weight:bold;text-transform:uppercase;", ";"], function (e) {
    return e.disabled ? "\n  color: #ccd6df;\n  background-color: #ccd6df;\n  border-color: #ccd6df;\n  color: #073142;\n  cursor: default;\n" : xe;
  });

  function we() {
    var e = y(["", ""]);
    return we = function we() {
      return e;
    }, e;
  }

  function Ee() {
    var e = y(["", ""]);
    return Ee = function Ee() {
      return e;
    }, e;
  }

  function ke() {
    var e = y(["", ""]);
    return ke = function ke() {
      return e;
    }, e;
  }

  function Ae() {
    var e = y(["", ""]);
    return Ae = function Ae() {
      return e;
    }, e;
  }

  function Se() {
    var e = y(["", ""]);
    return Se = function Se() {
      return e;
    }, e;
  }

  function je() {
    var e = y(["", ""]);
    return je = function je() {
      return e;
    }, e;
  }

  var Ne = function Ne(e) {
    return function (t) {
      var r = t.target;
      return e(r.value);
    };
  },
      Ce = function Ce(e) {
    return null != e && "" !== e;
  },
      Pe = function Pe(e) {
    return null == e || "" === e;
  },
      Te = v.form(je(), "\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;       \n  padding: 25px; \n  background-color: #fff;\n  border-radius: 10px;   \n  width: 400px; \n"),
      De = function De(e) {
    var r = e.name,
        n = e.label,
        o = e.value,
        i = T(e, ["name", "label", "value"]),
        a = ve(t.useState(!1), 2),
        u = a[0],
        c = a[1],
        s = {
      error: u && Pe(o),
      helperText: u && Pe(o) ? "Required" : " "
    };
    return g.createElement(l, Object.assign({
      label: n || r,
      placeholder: r,
      name: r,
      id: r,
      value: o,
      onBlur: c
    }, s, i));
  },
      Fe = v.h3(Se(), "\n  font-size: 24px;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  color: #073142;\n  font-family: 'Open Sans Condensed', sans-serif;\n  text-transform: uppercase;\n"),
      _e = v(De)(Ae(), "\n  margin-bottom: 10px !important;\n"),
      Re = v.div(ke(), "\n  margin-top: 30px;  \n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: nowrap;\n  flex: 0 0 auto;\n"),
      Be = v.div(Ee(), "\n  color: #D20020; \n  margin-right: 10px; \n"),
      Ie = v(P)(we(), Oe),
      Ve = function e(t) {
    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;
    W(this, e), this.label = r, this.value = t;
  },
      qe = function (e) {
    function t() {
      return W(this, t), K(this, J(t).apply(this, arguments));
    }

    return X(t, e), t;
  }(Ve),
      Le = function Le(e) {
    return g.createElement(u, Object.assign({}, e, {
      isMulti: !0
    }));
  },
      ze = {
    prefix: "fas",
    iconName: "minus",
    icon: [448, 512, [], "f068", "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]
  },
      Ue = {
    prefix: "fas",
    iconName: "plus",
    icon: [448, 512, [], "f067", "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"]
  },
      We = x.greyFive,
      He = x.greySix,
      Me = x.white,
      Qe = r.css(["display:flex;flex-direction:column;background-color:#fff;border-radius:10px;color:#575858;"]),
      Ge = r.css(["display:flex;min-height:34px;justify-content:space-between;align-items:center;border-radius:", ";padding-left:10px;background-color:", ";text-transform:uppercase;color:", ";"], function (e) {
    return e.expanded ? "10px 10px 0 0" : "10px";
  }, He, Me),
      Ye = r.css(["font-size:14px;font-weight:bold;"]),
      Ke = "\n  display: flex;\n  padding: 10px;\n  background-color: ".concat(We, ";\n  border-radius: 0 0 10px 10px;  \n"),
      Je = "\n  background-color: ".concat("#74858B", ";\n  height: 24px;\n  width: 24px;\n  cursor: pointer;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;  \n"),
      Ze = "\n  ".concat(Je, ";\n"),
      Xe = "\n  ".concat(Je, ";\n");

  function $e() {
    var e = y(["", ""]);
    return $e = function $e() {
      return e;
    }, e;
  }

  function et() {
    var e = y(["", ""]);
    return et = function et() {
      return e;
    }, e;
  }

  function tt() {
    var e = y(["", ""]);
    return tt = function tt() {
      return e;
    }, e;
  }

  function rt() {
    var e = y(["", ""]);
    return rt = function rt() {
      return e;
    }, e;
  }

  function nt() {
    var e = y(["", ""]);
    return nt = function nt() {
      return e;
    }, e;
  }

  function ot() {
    var e = y(["", ""]);
    return ot = function ot() {
      return e;
    }, e;
  }

  function it() {
    var e = y([""]);
    return it = function it() {
      return e;
    }, e;
  }

  function at() {
    var e = y(["", ""]);
    return at = function at() {
      return e;
    }, e;
  }

  function lt() {
    var e = y(["", ""]);
    return lt = function lt() {
      return e;
    }, e;
  }

  var ut = v.div(lt(), Qe),
      ct = v.div(at(), Ge),
      st = v.div(it()),
      dt = v.div(ot(), Ye),
      pt = v.div(nt(), Ke),
      ft = v.div(rt(), "\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;  \n  justify-content: center;\n"),
      mt = v.a(tt(), Ze),
      ht = v.a(et(), Xe),
      bt = v(c.FontAwesomeIcon)($e(), "\n  width: 12px;\n  height: 12px;\n"),
      gt = x.primaryFour,
      vt = r.css(["margin:0 !important;.radio_root{padding:4px;margin-left:0 !important;}.radio_checked{color:", " !important;}"], gt);

  function yt() {
    var e = y(["", ""]);
    return yt = function yt() {
      return e;
    }, e;
  }

  var xt = {
    root: "radio_root",
    checked: "radio_checked"
  },
      Ot = {
    label: "radio_label",
    root: "radio_wrapper"
  },
      wt = function wt(e) {
    var t = R({}, e);
    return g.createElement(s, Object.assign({
      classes: xt
    }, t));
  },
      Et = v(o)(yt(), vt),
      kt = function kt(e) {
    var t = e.label,
        r = e.value,
        n = T(e, ["label", "value"]);
    return g.createElement(Et, Object.assign({
      classes: Ot,
      control: g.createElement(wt, {
        value: r
      })
    }, n, {
      label: t
    }));
  },
      At = function () {
    function e(t, r) {
      var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
      W(this, e), this.Header = t, this.accessor = r, this.sortable = n;
    }

    return M(e, [{
      key: "withWidth",
      value: function value(e) {
        return this.width = e, this;
      }
    }, {
      key: "withId",
      value: function value(e) {
        return this.id = e, this;
      }
    }, {
      key: "withTotalHeader",
      value: function value(e) {
        return this.Footer = e, this;
      }
    }, {
      key: "withShow",
      value: function value(e) {
        return this.show = e, this;
      }
    }, {
      key: "withGetProps",
      value: function value(e) {
        return this.getProps = e, this;
      }
    }]), e;
  }(),
      St = x.greyThree,
      jt = x.greyFour,
      Nt = x.tableHighlight,
      Ct = x.white,
      Pt = r.css(["color:", ";font-family:Lato,sans-serif;font-size:14px;position:relative;display:flex;flex-direction:column;border:1px solid ", ";*{box-sizing:border-box;}.rt-table{flex:auto 1;display:flex;flex-direction:column;align-items:stretch;width:100%;border-collapse:collapse;overflow:auto;}.rt-thead{flex:1 0 auto;display:flex;flex-direction:column;user-select:none;font-weight:bold;}.rt-thead.-headerGroups{background:rgba(0,0,0,0.03);border-bottom:1px solid ", ";}.rt-thead.-filters{border-bottom:1px solid ", ";}.rt-thead.-filters input,.rt-thead.-filters select{border:1px solid rgba(0,0,0,0.1);background:", ";padding:5px 7px;font-size:inherit;border-radius:3px;font-weight:normal;outline:none;}.rt-thead.-filters .rt-th{border-right:1px solid ", ";overflow:inherit;}.rt-thead.-header{border-bottom:3px solid ", ";}.rt-thead .rt-tr{text-align:center;}.rt-thead .rt-th,.rt-thead .rt-td{padding:5px 5px;line-height:normal;position:relative;border-right:1px solid ", ";transition:box-shadow 0.3s cubic-bezier(0.175,0.885,0.32,1.275);box-shadow:inset 0 0 0 0 transparent;}.rt-thead .rt-th.-sort-asc,.rt-thead .rt-td.-sort-asc{box-shadow:inset 0 3px 0 0 rgba(0,0,0,0.6);}.rt-thead .rt-th.-sort-desc,.rt-thead .rt-td.-sort-desc{box-shadow:inset 0 -3px 0 0 rgba(0,0,0,0.6);}.rt-thead .rt-th.-cursor-pointer,.rt-thead .rt-td.-cursor-pointer{cursor:pointer;}.rt-thead .rt-th:last-child,.rt-thead .rt-td:last-child{border-right:0;}.rt-thead .rt-th:focus{outline:none;}.rt-thead .rt-resizable-header{overflow:visible;}.rt-thead .rt-resizable-header:last-child{overflow:hidden;}.rt-thead .rt-resizable-header-content{overflow:hidden;text-overflow:ellipsis;}.rt-thead .rt-header-pivot{border-right-color:#f7f7f7;}.rt-thead .rt-header-pivot:after,.rt-thead .rt-header-pivot:before{left:100%;top:50%;border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;}.rt-thead .rt-header-pivot:after{border-color:rgba(255,255,255,0);border-left-color:", ";border-width:8px;margin-top:-8px;}.rt-thead .rt-header-pivot:before{border-color:rgba(102,102,102,0);border-left-color:#f7f7f7;border-width:10px;margin-top:-10px;}.rt-tbody{flex:99999 1 auto;display:flex;flex-direction:column;overflow:auto;}.rt-tbody .rt-tr-group{border-bottom:solid 1px ", ";}.rt-tbody .rt-tr-group:last-child{border-bottom:0;}.rt-tbody .rt-td{border-right:1px solid ", ";}.rt-tbody .rt-td:last-child{border-right:0;}.rt-tbody .rt-expandable{cursor:pointer;text-overflow:clip;}.rt-tr-group{flex:1 0 auto;display:flex;flex-direction:column;align-items:stretch;}.rt-tr{flex:1 0 auto;display:inline-flex;}.rt-th,.rt-td{flex:1 0 0;white-space:nowrap;text-overflow:ellipsis;padding:7px 5px;overflow:hidden;transition:0.3s ease;transition-property:width,min-width,padding,opacity;}.rt-th.-hidden,.rt-td.-hidden{width:0 !important;min-width:0 !important;padding:0 !important;border:0 !important;opacity:0 !important;}.rt-expander{display:inline-block;position:relative;color:transparent;margin:0 10px;}.rt-expander:after{content:'';position:absolute;width:0;height:0;top:50%;left:50%;transform:translate(-50%,-50%) rotate(-90deg);border-left:5.04px solid transparent;border-right:5.04px solid transparent;border-top:7px solid rgba(0,0,0,0.8);transition:all 0.3s cubic-bezier(0.175,0.885,0.32,1.275);cursor:pointer;}.rt-expander.-open:after{transform:translate(-50%,-50%) rotate(0);}.rt-resizer{display:inline-block;position:absolute;width:36px;top:0;bottom:0;right:-18px;cursor:col-resize;z-index:10;}.rt-tfoot{flex:1 0 auto;display:flex;flex-direction:column;box-shadow:0 0 15px 0 rgba(0,0,0,0.15);}.rt-tfoot .rt-td{border-right:1px solid ", ";}.rt-tfoot .rt-td:last-child{border-right:0;}.-pagination{z-index:1;display:flex;justify-content:space-between;align-items:stretch;flex-wrap:wrap;padding:3px;border-top:2px solid ", ";}.-pagination input,.-pagination select{border:1px solid ", ";background:", ";padding:5px 7px;font-size:inherit;border-radius:3px;font-weight:normal;outline:none;}.-pagination .-btn{appearance:none;display:block;width:100%;height:100%;border:0;border-radius:3px;padding:6px;font-size:1em;color:rgba(0,0,0,0.6);background:rgba(0,0,0,0.1);transition:all 0.1s ease;cursor:pointer;outline:none;}.-pagination .-btn[disabled]{opacity:0.5;cursor:default;}.-pagination .-btn:not([disabled]):hover{background:rgba(0,0,0,0.3);color:", ";}.-pagination .-previous,.-pagination .-next{flex:1;text-align:center;}.-pagination .-center{flex:1.5;text-align:center;margin-bottom:0;display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;justify-content:space-around;}.-pagination .-pageInfo{display:inline-block;margin:3px 10px;white-space:nowrap;}.-pagination .-pageJump{display:inline-block;}.-pagination .-pageJump input{width:70px;text-align:center;}.-pagination .-pageSizeOptions{margin:3px 10px;}.rt-noData{display:block;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);background:rgba(255,255,255,0.8);transition:all 0.3s ease;z-index:1;pointer-events:none;padding:20px;color:rgba(0,0,0,0.5);}.-loading{display:block;position:absolute;left:0;right:0;top:0;bottom:0;background:rgba(255,255,255,0.8);transition:all 0.3s ease;z-index:-1;opacity:0;pointer-events:none;}.-loading > div{position:absolute;display:block;text-align:center;width:100%;top:50%;left:0;font-size:15px;color:rgba(0,0,0,0.6);transform:translateY(-52%);transition:all 0.3s cubic-bezier(0.25,0.46,0.45,0.94);}.-loading.-active{opacity:1;z-index:2;pointer-events:all;}.-loading.-active > div{transform:translateY(50%);}.rt-resizing .rt-th,.rt-resizing .rt-td{transition:none !important;cursor:col-resize;user-select:none;}"], jt, St, St, St, Ct, St, St, St, Ct, St, St, St, St, St, Ct, Ct),
      Tt = r.css([".rt-tr.-odd{background:rgba(0,0,0,0.03);}"]),
      Dt = r.css([".rt-tbody .rt-tr:not(.-padRow):hover{background:", ";}"], Nt);

  var Ft = r.css(["", ""], function (e) {
    return t = function (e) {
      var t = Pt;
      return e.theme && e.theme.table && (t = r.css(["", "", ""], t, e.theme.table)), e.striped && (t = r.css(["", "", ""], t, Tt)), e.highlight && (t = r.css(["", "", ""], t, Dt)), t;
    }(e), r.css(["", ""], t);
    var t;
  });

  function _t() {
    var e = y(["", ""]);
    return _t = function _t() {
      return e;
    }, e;
  }

  var Rt = v(p)(_t(), Ft),
      Bt = function (e) {
    function t(e, r, n) {
      var o;
      return W(this, t), (o = K(this, J(t).call(this, e, r, n))).Cell = function () {}, o;
    }

    return X(t, e), M(t, [{
      key: "withComponents",
      value: function value(e) {
        return this.Cell = function (t) {
          return e.map(function (e) {
            return e(t);
          });
        }, this;
      }
    }]), t;
  }(At),
      It = function It(e, t) {
    var r = null == e ? -1 / 0 : e,
        n = null == t ? -1 / 0 : t;
    return r > n ? 1 : r < n ? -1 : 0;
  },
      Vt = function Vt(e, t) {
    return null === t.value || e.value > t.value ? 1 : -1;
  },
      qt = x.white,
      Lt = x.primaryFour,
      zt = x.greyThree,
      Ut = x.greySeven,
      Wt = x.primaryOne,
      Ht = x.primaryThree,
      Mt = r.css(["background-color:", ";border:1px solid ", ";box-shadow:1px 1px 5px ", ";padding:12px;position:absolute;text-align:left;width:280px;z-index:2;display:flex;flex-direction:column;font-weight:normal;&.text{height:262px;}&.date,.number{height:413px;}.advanced-filter__title{margin-top:0;}.advanced-filter__fields{margin-bottom:12px;&:last-of-type{margin-top:24px;}.advanced-filter__date-field{border-radius:0 !important;display:block;margin-bottom:6px;padding:3px !important;width:100%;}.number-input,.text-input{border-radius:0 !important;display:block;margin-bottom:6px;width:100%;}}"], qt, Lt, zt),
      Qt = r.css(["color:", ";margin-top:0;margin-bottom:10px;font-size:18px;"], Wt),
      Gt = r.css(["width:100%;min-height:auto;border-radius:24px;display:inline-block;height:24px;font-size:14px;margin-bottom:6px;padding:2px 6px 3px 6px;&.active,&.apply{background-color:", ";color:", ";}&.inactive,&.cancel,&.disabled,&.apply:disabled{background-color:", ";border:1px solid ", ";color:", ";}"], Lt, qt, qt, Ut, Wt),
      Yt = r.css(["", ";"], Gt),
      Kt = r.css(["background-color:", ";color:", ";"], Lt, qt),
      Jt = r.css(["background-color:", ";border:1px solid ", ";color:", ";"], qt, Ut, Wt),
      Zt = r.css(["", ";", ";"], Gt, function (e) {
    return e.disabled ? Jt : Kt;
  }),
      Xt = r.css(["", ";background-color:", ";color:", ";"], Gt, Ht, qt),
      $t = r.css(["", ";background-color:", ";border:1px solid ", ";color:", ";"], Gt, qt, Ut, Wt);

  function er() {
    var e = y(["", ""]);
    return er = function er() {
      return e;
    }, e;
  }

  function tr() {
    var e = y(["", ""]);
    return tr = function tr() {
      return e;
    }, e;
  }

  function rr() {
    var e = y(["", ""]);
    return rr = function rr() {
      return e;
    }, e;
  }

  function nr() {
    var e = y(["", ""]);
    return nr = function nr() {
      return e;
    }, e;
  }

  function or() {
    var e = y(["", ""]);
    return or = function or() {
      return e;
    }, e;
  }

  function ir() {
    var e = y(["", ""]);
    return ir = function ir() {
      return e;
    }, e;
  }

  var ar = {
    showFilter: !1,
    applied: void 0,
    current: void 0
  },
      lr = v.h4(ir(), Qt),
      ur = v(P)(or(), Yt),
      cr = v(P)(nr(), Zt),
      sr = v(P)(rr(), Xt),
      dr = v(P)(tr(), $t),
      pr = v.div(er(), Mt),
      fr = function (e) {
    function t(e) {
      var r;
      return W(this, t), $(Y(r = K(this, J(t).call(this, e))), "setCurrent", function (e) {
        r.setState({
          current: e
        });
      }), $(Y(r), "applyFilter", function () {
        r.setState(function (e) {
          return {
            showFilter: !1,
            applied: e.current
          };
        }), r.props.onChange(r.state.current);
      }), $(Y(r), "cancelFilter", function () {
        r.setState(function (e) {
          return {
            showFilter: !1,
            current: e.applied
          };
        });
      }), $(Y(r), "clearFilter", function () {
        var e = r.props.onChange;
        r.setState(ar), e({
          clearFilter: !0
        });
      }), $(Y(r), "showFilter", function () {
        r.setState({
          showFilter: !0
        });
      }), $(Y(r), "isValid", function () {
        return r.state.current && r.state.current.valid;
      }), $(Y(r), "activeClass", function () {
        return r.state.applied ? "active" : "inactive";
      }), $(Y(r), "renderHiddenFilter", function () {
        return g.createElement(ur, {
          className: "".concat(r.activeClass()),
          onClick: r.showFilter
        }, " Filter ");
      }), $(Y(r), "renderFilter", function () {
        var e = r.props,
            t = e.render,
            n = e.column,
            o = r.state.current;
        return g.createElement(pr, null, g.createElement(lr, null, n.Header), t(o, r.setCurrent), g.createElement(cr, {
          disabled: !r.isValid(),
          onClick: r.applyFilter
        }, "Apply"), g.createElement(sr, {
          onClick: r.clearFilter
        }, "Clear"), g.createElement(dr, {
          onClick: r.cancelFilter
        }, "Cancel"));
      }), r.state = ar, r;
    }

    return X(t, e), M(t, [{
      key: "render",
      value: function value() {
        var e = this.state.showFilter;
        return g.createElement("div", {
          className: "advanced-filter"
        }, e ? this.renderFilter() : this.renderHiddenFilter());
      }
    }]), t;
  }(t.Component),
      mr = {
    menu: function menu(e) {
      return Object.assign(e, {
        zIndex: 1e3
      });
    }
  },
      hr = function hr(e) {
    return g.createElement(Le, Object.assign({}, e, {
      styles: mr
    }));
  };

  function br(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function gr(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? br(Object(r), !0).forEach(function (t) {
        $(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : br(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  var vr = {
    valid: !1
  },
      yr = function (e) {
    function t(e) {
      var r;
      return W(this, t), $(Y(r = K(this, J(t).call(this, e))), "getOrderedUniqueValues", function (e) {
        return f(e.data).map(function (t) {
          return e.column.accessor(t) ? new qe(!0, "Y") : new qe(!1, "(Blank)");
        }).uniqBy("value").value().sort(Vt);
      }), $(Y(r), "isValid", function (e) {
        return e && e.length > 0;
      }), r.state = {
        multiSelectOptions: r.getOrderedUniqueValues(e)
      }, r;
    }

    return X(t, e), M(t, [{
      key: "componentWillReceiveProps",
      value: function value(e) {
        f.isEqual(e.data, this.props.data) || this.setState({
          multiSelectOptions: this.getOrderedUniqueValues(e)
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this;
        return g.createElement(fr, Object.assign({}, this.props, {
          render: function render() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : vr,
                r = arguments.length > 1 ? arguments[1] : void 0;
            return g.createElement("div", null, g.createElement("div", {
              className: "advanced-filter__fields"
            }, g.createElement(hr, {
              value: t.multiSelectValues,
              onChange: function onChange(n) {
                return r(gr({}, t, {
                  multiSelectValues: n,
                  valid: e.isValid(n)
                }));
              },
              options: e.state.multiSelectOptions
            })));
          }
        }));
      }
    }]), t;
  }(g.Component),
      xr = {
    EQUALS: "===",
    GREATER_THAN: ">",
    GREATER_THAN_EQUAL_TO: ">=",
    SMALLER_THAN: "<",
    SMALLER_THAN_EQUAL_TO: "<=",
    BETWEEN: "><",
    STARTS_WITH: "a%",
    CONTAINS: "%a%"
  };

  function Or(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function wr(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Or(Object(r), !0).forEach(function (t) {
        $(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Or(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  var Er = function Er(e, t, r, n) {
    if (n && n.length > 0) return !0;
    if (!t) return !1;

    if (e === xr.BETWEEN) {
      if (!r) return !1;
      var o = i(r);
      return i(t).isBefore(o);
    }

    return !0;
  },
      kr = {
    operator: xr.EQUALS,
    fromDate: void 0,
    toDate: void 0,
    valid: !1
  },
      Ar = function (e) {
    function t(e) {
      var r;
      return W(this, t), $(Y(r = K(this, J(t).call(this, e))), "getOrderedUniqueValues", function (e) {
        return f(e.data).map(function (t) {
          var r = e.column.accessor(t);
          if (!r) return new qe(null, "(Blank)");
          var n = i(r).format(ee.date);
          return new qe(n);
        }).uniqBy("value").value().sort(function (e, t) {
          return null === t.value || i(e.label, ee.date).isAfter(i(t.label, ee.date)) ? 1 : -1;
        });
      }), r.state = {
        multiSelectOptions: r.getOrderedUniqueValues(e)
      }, r;
    }

    return X(t, e), M(t, [{
      key: "componentWillReceiveProps",
      value: function value(e) {
        var t = this.props.data;
        f.isEqual(e.data, t) || this.setState({
          multiSelectOptions: this.getOrderedUniqueValues(e)
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this;
        return g.createElement(fr, Object.assign({}, this.props, {
          render: function render() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : kr,
                r = arguments.length > 1 ? arguments[1] : void 0;
            return g.createElement("div", null, g.createElement("div", {
              className: "advanced-filter__fields"
            }, g.createElement(hr, {
              value: t.multiSelectValues,
              onChange: function onChange(n) {
                return r(wr({}, t, {
                  multiSelectValues: n,
                  valid: Er(t.operator, t.fromDate, t.toDate, n),
                  type: e.props.column.type
                }));
              },
              options: e.state.multiSelectOptions
            })), g.createElement("div", {
              className: "advanced-filter__fields"
            }, g.createElement(d, {
              onChange: function onChange(e, n) {
                r(wr({}, t, {
                  operator: n
                }));
              },
              name: "dateFilter",
              value: t.operator
            }, g.createElement(kt, {
              value: xr.EQUALS,
              label: "Equals"
            }), g.createElement(kt, {
              value: xr.GREATER_THAN,
              label: "Greater than"
            }), g.createElement(kt, {
              value: xr.GREATER_THAN_EQUAL_TO,
              label: "Greater than or equal to"
            }), g.createElement(kt, {
              value: xr.SMALLER_THAN,
              label: "Smaller than"
            }), g.createElement(kt, {
              value: xr.SMALLER_THAN_EQUAL_TO,
              label: "Smaller than or equal to"
            }), g.createElement(kt, {
              value: xr.BETWEEN,
              label: "Between"
            }))), g.createElement("div", {
              className: "advanced-filter__fields"
            }, g.createElement(ie, {
              value: t.fromDate,
              type: e.props.column.type,
              onChange: function onChange(e) {
                var n = Er(t.operator, e, t.toDate, t.multiSelectValues);
                r(wr({}, t, {
                  fromDate: e,
                  valid: n
                }));
              }
            }), t.operator === xr.BETWEEN && g.createElement(ie, {
              value: t.toDate,
              type: e.props.column.type,
              onChange: function onChange(e) {
                var n = Er(t.operator, t.fromDate, e, t.multiSelectValues);
                r(wr({}, t, {
                  toDate: e,
                  valid: n
                }));
              }
            })));
          }
        }));
      }
    }]), t;
  }(g.Component);

  function Sr(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function jr(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Sr(Object(r), !0).forEach(function (t) {
        $(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sr(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  var Nr = function Nr(e, t, r) {
    return !Number.isNaN(Number(t)) && (e !== xr.BETWEEN || !Number.isNaN(Number(r)) && r > t);
  },
      Cr = {
    operator: xr.EQUALS,
    number: "",
    endNumber: "",
    valid: !1
  },
      Pr = function (e) {
    function t(e) {
      var r;
      return W(this, t), $(Y(r = K(this, J(t).call(this, e))), "getOrderedUniqueValues", function (e) {
        return f(e.data).map(function (t) {
          var r = e.column.accessor(t);
          if (void 0 === r || "" === r || null === r) return new qe(null, "(Blank)");
          var n = r;
          return e.column.Cell && "function" == typeof e.column.Cell && (n = e.column.Cell({
            value: r
          })), new qe(r, n);
        }).uniqBy("value").value().sort(Vt);
      }), $(Y(r), "specificRender", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Cr,
            t = arguments.length > 1 ? arguments[1] : void 0;
        return g.createElement("div", null, g.createElement("div", {
          className: "advanced-filter__fields"
        }, g.createElement(hr, {
          name: "unique-number-select",
          value: e.multiSelectValues,
          onChange: function onChange(r) {
            return t(jr({}, e, {
              multiSelectValues: r,
              valid: r.length > 0
            }));
          },
          options: r.state.multiSelectOptions
        })), g.createElement("div", {
          className: "advanced-filter__fields"
        }, g.createElement(d, {
          onChange: function onChange(r, n) {
            t(jr({}, e, {
              operator: n
            }));
          },
          name: "numberFilter",
          value: e.operator
        }, g.createElement(kt, {
          value: xr.EQUALS,
          label: "Equals"
        }), g.createElement(kt, {
          value: xr.GREATER_THAN,
          label: "Greater than"
        }), g.createElement(kt, {
          value: xr.GREATER_THAN_EQUAL_TO,
          label: "Greater than or equal to"
        }), g.createElement(kt, {
          value: xr.SMALLER_THAN,
          label: "Smaller than"
        }), g.createElement(kt, {
          value: xr.SMALLER_THAN_EQUAL_TO,
          label: "Smaller than or equal to"
        }), g.createElement(kt, {
          value: xr.BETWEEN,
          label: "Between"
        }))), g.createElement("div", {
          className: "advanced-filter__fields"
        }, g.createElement("input", {
          className: "number-input",
          type: "number",
          min: "0",
          pattern: "[0-9]",
          onChange: function onChange(r) {
            var n = r.target,
                o = parseFloat(n.value),
                i = Nr(e.operator, o, e.endNumber);
            t(jr({}, e, {
              number: o,
              valid: i
            }));
          },
          value: e.number
        }), e.operator === xr.BETWEEN && g.createElement("input", {
          className: "number-input",
          type: "number",
          min: "0",
          pattern: "[0-9]",
          onChange: function onChange(r) {
            var n = r.target,
                o = parseFloat(n.value),
                i = Nr(e.operator, e.number, o);
            t(jr({}, e, {
              endNumber: o,
              valid: i
            }));
          },
          value: e.endNumber
        })));
      }), r.state = {
        multiSelectOptions: r.getOrderedUniqueValues(e)
      }, r;
    }

    return X(t, e), M(t, [{
      key: "componentWillReceiveProps",
      value: function value(e) {
        var t = this.props.data;
        f.isEqual(e.data, t) || this.setState({
          multiSelectOptions: this.getOrderedUniqueValues(e)
        });
      }
    }, {
      key: "render",
      value: function value() {
        return g.createElement(fr, Object.assign({}, this.props, {
          render: this.specificRender
        }));
      }
    }]), t;
  }(g.Component),
      Tr = function Tr(e) {
    return function (t) {
      var r = t.filter,
          n = t.onChange;
      return g.createElement("select", {
        onChange: function onChange(e) {
          return n(e.target.value);
        },
        style: {
          marginTop: "4px",
          width: "100%"
        },
        value: r ? r.value : "all"
      }, g.createElement("option", {
        value: "all"
      }, "Show All"), e.length > 0 && e.map(function (e) {
        return g.createElement("option", {
          key: e,
          value: e
        }, "Category ", e);
      }));
    };
  };

  function Dr(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function Fr(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Dr(Object(r), !0).forEach(function (t) {
        $(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Dr(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  var _r,
      Rr,
      Br,
      Ir = {
    operator: xr.CONTAINS,
    string: "",
    valid: !1
  },
      Vr = function (e) {
    function t(e) {
      var r;
      return W(this, t), $(Y(r = K(this, J(t).call(this, e))), "getOrderedUniqueValues", function (e) {
        return f(e.data).map(function (t) {
          var r = e.column.accessor(t);
          return r && "" !== r ? new qe(r) : new qe(null, "(Blank)");
        }).uniqBy("value").value().sort(Vt);
      }), $(Y(r), "isValid", function (e, t) {
        return e && e.length > 0 || !!t;
      }), r.state = {
        multiSelectOptions: r.getOrderedUniqueValues(e)
      }, r;
    }

    return X(t, e), M(t, [{
      key: "componentWillReceiveProps",
      value: function value(e) {
        var t = this.props.data;
        f.isEqual(e.data, t) || this.setState({
          multiSelectOptions: this.getOrderedUniqueValues(e)
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = this.state.multiSelectOptions;
        return g.createElement(fr, Object.assign({}, this.props, {
          render: function render() {
            var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ir,
                n = arguments.length > 1 ? arguments[1] : void 0;
            return g.createElement("div", null, g.createElement("div", {
              className: "advanced-filter__fields"
            }, g.createElement(Le, {
              value: r.multiSelectValues,
              onChange: function onChange(t) {
                return n(Fr({}, r, {
                  multiSelectValues: t,
                  valid: e.isValid(t, r.string)
                }));
              },
              options: t
            })), g.createElement("div", {
              className: "advanced-filter__fields"
            }, g.createElement(d, {
              onChange: function onChange(e, t) {
                n(Fr({}, r, {
                  operator: t
                }));
              },
              name: "textFilter",
              value: r.operator
            }, g.createElement(kt, {
              value: xr.CONTAINS,
              label: "Contains"
            }), g.createElement(kt, {
              value: xr.STARTS_WITH,
              label: "Starts with"
            }))), g.createElement("div", {
              className: "advanced-filter__fields"
            }, g.createElement("input", {
              className: "text-input",
              onChange: function onChange(t) {
                return n(Fr({}, r, {
                  string: t.target.value,
                  valid: e.isValid(r.multiSelectValues, t.target.value)
                }));
              },
              value: r.string
            })));
          }
        }));
      }
    }]), t;
  }(g.Component),
      qr = function qr(e, t) {
    var r = e.value,
        n = r.multiSelectValues;
    if (r.clearFilter) return !0;
    var o = t[e.id];
    return !!f.find(n, {
      value: o
    });
  },
      Lr = ($(_r = {}, xr.EQUALS, function (e, t) {
    return m(e).isSame(t);
  }), $(_r, xr.GREATER_THAN, function (e, t) {
    return m(e).isAfter(t);
  }), $(_r, xr.GREATER_THAN_EQUAL_TO, function (e, t) {
    return m(e).isSameOrAfter(t);
  }), $(_r, xr.SMALLER_THAN, function (e, t) {
    return m(e).isBefore(t);
  }), $(_r, xr.SMALLER_THAN_EQUAL_TO, function (e, t) {
    return m(e).isSameOrBefore(t);
  }), $(_r, xr.BETWEEN, function (e, t, r) {
    return m(e).isBetween(m(t), m(r));
  }), _r),
      zr = function zr(e, t) {
    var r = e.value,
        n = r.operator,
        o = r.fromDate,
        i = r.toDate,
        a = r.clearFilter,
        l = r.multiSelectValues,
        u = t[e.id];
    return !!a || (l && l.length ? !!f.find(l, {
      value: u ? m(u).format(ee.date) : null
    }) : !Lr[n] || Lr[n](u, o, i));
  },
      Ur = ($(Rr = {}, xr.EQUALS, function (e, t) {
    return e === t;
  }), $(Rr, xr.GREATER_THAN, function (e, t) {
    return e > t;
  }), $(Rr, xr.GREATER_THAN_EQUAL_TO, function (e, t) {
    return e >= t;
  }), $(Rr, xr.SMALLER_THAN, function (e, t) {
    return e < t;
  }), $(Rr, xr.SMALLER_THAN_EQUAL_TO, function (e, t) {
    return e <= t;
  }), $(Rr, xr.BETWEEN, function (e, t, r) {
    return e >= t && e <= r;
  }), Rr),
      Wr = function Wr(e, t) {
    var r = e.value,
        n = r.operator,
        o = r.number,
        i = r.endNumber,
        a = r.multiSelectValues,
        l = r.clearFilter,
        u = t[e.id];
    return !!l || (a && a.length ? !!f.find(a, {
      value: void 0 === u ? null : u
    }) : !Ur[n] || Ur[n](u, o, i));
  },
      Hr = ($(Br = {}, xr.STARTS_WITH, function (e, t) {
    return f.startsWith(e, t);
  }), $(Br, xr.CONTAINS, function (e, t) {
    return f.includes(e, t);
  }), Br),
      Mr = function Mr(e, t) {
    var r = e.value,
        n = r.operator,
        o = r.string,
        i = r.clearFilter,
        a = r.multiSelectValues,
        l = t[e.id];
    return !!i || (a && a.length ? !!f.find(a, {
      value: l || null
    }) : !Hr[n] || Hr[n](l && l.toLowerCase(), o.toLowerCase()));
  };

  function Qr(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function Gr(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Qr(Object(r), !0).forEach(function (t) {
        $(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Qr(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function Yr(e, t) {
    return Gr({}, e, {
      filterable: !0,
      Filter: function Filter(e) {
        return g.createElement(Vr, Object.assign({}, e, {
          data: t
        }));
      },
      filterMethod: Mr
    });
  }

  function Kr(e, t) {
    return Gr({}, e, {
      filterable: !0,
      Filter: function Filter(e) {
        return g.createElement(yr, Object.assign({}, e, {
          data: t
        }));
      },
      filterMethod: qr
    });
  }

  function Jr(e, t) {
    return Gr({}, e, {
      filterable: !0,
      filterMethod: function filterMethod(e, t) {
        return "all" === e.value || t[e.id] === e.value;
      },
      Filter: Tr(t)
    });
  }

  function Zr(e, t) {
    return Gr({}, e, {
      filterable: !0,
      Filter: function Filter(r) {
        return g.createElement(Pr, Object.assign({}, r, {
          data: t,
          key: e.Header
        }));
      },
      filterMethod: Wr,
      type: "number"
    });
  }

  function Xr(e, t) {
    return Gr({}, e, {
      filterable: !0,
      Filter: function Filter(r) {
        return g.createElement(Pr, Object.assign({}, r, {
          data: t,
          key: e.Header
        }));
      },
      filterMethod: Wr,
      type: "float"
    });
  }

  function $r(e, t) {
    return Gr({}, e, {
      filterable: !0,
      Filter: function Filter(e) {
        return g.createElement(Ar, Object.assign({}, e, {
          data: t
        }));
      },
      filterMethod: zr,
      type: "date"
    });
  }

  function en(e, t) {
    return Gr({}, e, {
      filterable: !0,
      Filter: function Filter(e) {
        return g.createElement(Ar, Object.assign({}, e, {
          data: t
        }));
      },
      filterMethod: zr,
      type: "dateTime"
    });
  }

  function tn(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ee.date,
        r = 0 === Object.keys(t).length ? ee.date : t;
    if (!e.value) return null;
    var n = m(e.value);
    return n.isValid() ? n.format(r) : e.value;
  }

  function rn(e) {
    var t = e.value;
    return t && !Number.isNaN(Number(t)) || 0 === t ? "".concat(t, " %") : e.value;
  }

  function nn(e) {
    return void 0 === e.value || null === e.value ? "" : e.value.toString();
  }

  var on = {
    date: tn,
    dateTime: function dateTime(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ee.dateTime;
      return tn(e, 0 === Object.keys(t).length ? ee.dateTime : t);
    },
    float: function float(e) {
      if (void 0 === e.value || null === e.value) return "";
      var t = nn(e);
      return t.indexOf(".") >= 0 ? t : "".concat(t, ".0");
    },
    percentage: rn,
    boolean: function boolean(e) {
      return e.value && "Y";
    },
    number: nn,
    duration: function duration(e) {
      var t = parseInt(f.first(e.value.split(":")), 10),
          r = parseInt(f.last(e.value.split(":")), 10);
      return "".concat("".concat(t).padStart(2, "0"), ":").concat("".concat(r).padStart(2, "0"));
    },
    multiline: function multiline(e) {
      return (e.value || []).map(function (e, t) {
        return g.createElement("div", {
          key: t,
          className: "ellipsis"
        }, e);
      });
    },
    nonZeroNumber: function nonZeroNumber(e) {
      return e && e.value ? nn(e) : "";
    },
    nonZeroPercentage: function nonZeroPercentage(e) {
      return e && e.value ? rn(e) : "";
    }
  };

  function an(e) {
    return on[e];
  }

  var ln = "NEW_NOTIFICATION",
      un = "REMOVE_NOTIFICATION",
      cn = "CLOSE_NOTIFICATION",
      sn = function () {
    function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
        id: h(),
        isClosing: !1
      };
      W(this, e), $(this, "id", void 0), $(this, "type", void 0), $(this, "text", void 0), $(this, "duration", void 0), $(this, "isClosing", !1), this.id = t.id, this.type = t.type, this.text = t.text, this.duration = t.duration, this.isClosing = t.isClosing;
    }

    return M(e, [{
      key: "setId",
      value: function value(e) {
        return this.id = e, this;
      }
    }, {
      key: "setType",
      value: function value(e) {
        return this.type = e, this;
      }
    }, {
      key: "setText",
      value: function value(e) {
        return this.text = e, this;
      }
    }, {
      key: "setDuration",
      value: function value(e) {
        return this.duration = e, this;
      }
    }, {
      key: "setIsClosing",
      value: function value(e) {
        return this.isClosing = e, this;
      }
    }]), e;
  }(),
      dn = "INFO";

  function pn(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function fn(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? pn(Object(r), !0).forEach(function (t) {
        $(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : pn(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  var mn = cn,
      hn = ln,
      bn = un,
      gn = "ERROR",
      vn = dn,
      yn = "SUCCESS",
      xn = "WARNING",
      On = function On(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
    return {
      type: hn,
      payload: fn({}, new sn().setType(vn).setText(e).setDuration(t))
    };
  },
      wn = function wn(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
    return {
      type: hn,
      payload: fn({}, new sn().setType(xn).setText(e).setDuration(t))
    };
  },
      En = function En(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
    return {
      type: hn,
      payload: fn({}, new sn().setType(gn).setText(e).setDuration(t))
    };
  },
      kn = function kn(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
    return {
      type: hn,
      payload: fn({}, new sn().setType(yn).setText(e).setDuration(t))
    };
  },
      An = function An(e) {
    var t = e.id;
    return {
      type: mn,
      payload: {
        id: t
      }
    };
  },
      Sn = function Sn(e) {
    var t = e.id;
    return {
      type: bn,
      payload: {
        id: t
      }
    };
  },
      jn = function () {
    function e(t) {
      W(this, e), this.data = t || [];
    }

    return M(e, [{
      key: "has",
      value: function value(e) {
        return !!f.find(this.data, {
          id: e
        });
      }
    }, {
      key: "find",
      value: function value(e) {
        return f.find(this.data, {
          id: e
        });
      }
    }, {
      key: "findIndex",
      value: function value(e) {
        return f.findIndex(this.data, {
          id: e
        });
      }
    }, {
      key: "length",
      value: function value() {
        return this.data.length;
      }
    }, {
      key: "getByIndex",
      value: function value(e) {
        return this.data[e];
      }
    }, {
      key: "loop",
      value: function value(e) {
        f.forEach(this.data, function (t, r) {
          return e(t, r);
        });
      }
    }, {
      key: "map",
      value: function value(e) {
        return f.map(this.data, e);
      }
    }, {
      key: "data",
      get: function get() {
        return this._data;
      },
      set: function set(e) {
        this._data = e;
      }
    }]), e;
  }(),
      Nn = cn,
      Cn = ln,
      Pn = un,
      Tn = function Tn() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
        t = arguments.length > 1 ? arguments[1] : void 0;

    switch (t.type) {
      case Cn:
        return f.concat(e, new sn(t.payload));

      case Nn:
        return f.map(e, function (e) {
          return e.id === t.payload.id ? new sn(e).setIsClosing(!0) : e;
        });

      case Pn:
        return f.without(e, new jn(e).find(t.payload.id));

      default:
        return e;
    }
  },
      Dn = t.createContext(),
      Fn = function Fn(e) {
    var r = e.children,
        n = ve(t.useReducer(Tn, []), 2),
        o = n[0],
        i = n[1];
    return g.createElement(Dn.Provider, {
      value: [o, i]
    }, r);
  },
      _n = function _n(e, t) {
    return function (r, n) {
      return t(e(r, n));
    };
  },
      Rn = function Rn(e, t) {
    return function (r) {
      var n = r.id;
      return t(e({
        id: n
      }));
    };
  },
      Bn = function Bn() {
    var e = ve(t.useContext(Dn), 2),
        r = e[0],
        n = e[1];
    return [r, {
      closeNotification: Rn(An, n),
      removeNotification: Rn(Sn, n)
    }];
  },
      In = function In() {
    var e = ve(t.useContext(Dn), 2)[1];
    return [{
      infoNotification: _n(On, e),
      warningNotification: _n(wn, e),
      errorNotification: _n(En, e),
      successNotification: _n(kn, e)
    }];
  };

  function Vn(e) {
    return function (e) {
      if (Array.isArray(e)) {
        for (var t = 0, r = new Array(e.length); t < e.length; t++) {
          r[t] = e[t];
        }

        return r;
      }
    }(e) || function (e) {
      if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  Fn.displayName = "NotificationProvider";

  var qn = function qn() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 15,
        t = e - 1 - 1;
    return r.css(["&.duration-", " .message-progress{-webkit-animation:runProgress ", "s linear forwards ", "s;-moz-animation:runProgress ", "s linear forwards ", "s;-o-animation:runProgress ", "s linear forwards ", "s;-ms-animation:runProgress ", "s linear forwards ", "s;animation:runProgress ", "s linear forwards ", "s;}"], e, t, 1, t, 1, t, 1, t, 1, t, 1);
  },
      Ln = r.css(["@keyframes runProgress{0%{width:0;background:rgba(255,255,255,0.3);}100%{width:100%;background:rgba(255,255,255,1);}}@keyframes fadeIn{0%{opacity:0;}100%{opacity:1;}}@keyframes fadeOut{0%{opacity:1;transform:translateY(0px);}100%{opacity:0;transform:translateY(-30px);}}border-radius:5px;", ";", ";", ";", ";", ";", ";", ";", ";", ";position:relative;padding:", "px 0;width:100%;margin-bottom:10px;opacity:1;transform:translateY(0px);animation:fadeIn ", "s linear forwards;&.is-closing{animation:fadeOut ", "s linear forwards;}&.error{background-color:darkred;color:white;}&.warning{background-color:#ec971f;color:white;}&.success{background-color:#449d44;color:white;}&.info{background-color:#337ab7;color:white;}.text-container{width:100%;display:block;text-align:center;position:relative;}.text{padding:0 ", "px;white-space:pre-wrap;display:inline-block;text-align:left;}.message-icon,.close-icon{background:transparent;border:0;height:", "px;position:absolute;top:", "px;i{font-size:", "px;vertical-align:top;}}.message-icon{left:", "px;}.close-icon{right:", "px;cursor:pointer;color:white;}&.timed{padding-bottom:", "px;.progress-container{position:absolute;left:", "px;right:", "px;bottom:-", "px;text-align:center;height:", "px;}.message-progress{width:0;height:", "px;background:rgba(255,255,255,0.3);position:relative;display:inline-block;border-radius:3px;box-shadow:inset 0 1px 1px rgba(0,0,0,0.05),0 -1px 0 rgba(255,255,255,0.6);}}"], qn(10), qn(15), qn(20), qn(25), qn(30), qn(45), qn(60), qn(90), qn(120), 7, 1, 1, 32, 18, 7, 18, 14, 25, 14, 32, 32, 7, 7, 2);

  function zn() {
    var e = y(["", ""]);
    return zn = function zn() {
      return e;
    }, e;
  }

  var Un = dn,
      Wn = {
    INFO: {
      icon: "info"
    },
    ERROR: {
      icon: "bug"
    },
    WARNING: {
      icon: "exclamation-triangle"
    },
    SUCCESS: {
      icon: "check"
    }
  },
      Hn = v.div(zn(), Ln),
      Mn = function Mn(e) {
    var t = e.id,
        r = e.type,
        n = void 0 === r ? Un : r,
        o = e.text,
        i = void 0 === o ? "" : o,
        a = e.duration,
        l = e.onClose,
        u = e.isClosing,
        s = void 0 !== u && u,
        d = void 0 !== a,
        p = "";
    s && (p = " is-closing");
    var f = "";
    !s && d && (f = " duration-".concat(a));
    var m = "";
    d && (m = " timed");
    var h = Wn[n].icon;
    return g.createElement(Hn, {
      className: "message ".concat(n.toLowerCase()).concat(m).concat(f).concat(p)
    }, g.createElement("span", {
      className: "message-icon"
    }, g.createElement(c.FontAwesomeIcon, {
      icon: h
    })), g.createElement("span", {
      className: "text-container"
    }, g.createElement("span", {
      className: "text"
    }, i), g.createElement("div", {
      className: "progress-container"
    }, g.createElement("div", {
      className: "message-progress"
    }))), g.createElement("button", {
      type: "button",
      className: "close-icon",
      onClick: l && function () {
        l({
          id: t
        });
      }
    }, g.createElement(c.FontAwesomeIcon, {
      icon: "times"
    })));
  };

  function Qn() {
    var e = y(["\n  ", "\n"]);
    return Qn = function Qn() {
      return e;
    }, e;
  }

  var Gn = [],
      Yn = v.div(Qn(), "\n  position: absolute;\n  left: 25px;\n  right: 25px;\n  height: 0;\n  z-index: 1;\n"),
      Kn = function Kn(e) {
    var r = e.notification,
        n = ve(In(), 1)[0],
        o = n.infoNotification,
        i = n.warningNotification,
        a = n.errorNotification,
        l = n.successNotification;
    return t.useEffect(function () {
      if (r) switch (r.type) {
        case "SUCCESS":
          l(r.message);
          break;

        case "ERROR":
          a(r.message);
          break;

        case "WARNING":
          i(r.message);
          break;

        case "INFO":
          o(r.message);
          break;

        default:
          o(r.message);
      }
    }, [r]), null;
  };

  Kn.propTypes = {
    notification: b.shape({
      type: b.string.isRequired,
      message: b.string.isRequired
    })
  };
  e.Button = P, e.Card = function (e) {
    var t = e.children,
        r = T(e, ["children"]);
    return g.createElement(_, r, t);
  }, e.Checkbox = function (e) {
    var t = e.label,
        r = e.value,
        n = e.indeterminate,
        o = T(e, ["label", "value", "indeterminate"]);
    return g.createElement(U, Object.assign({
      classes: L,
      control: g.createElement(z, {
        value: r,
        indeterminate: n
      })
    }, o, {
      label: t
    }));
  }, e.Colors = x, e.DayPickerInput = ie, e.GeneralErrorMessage = function () {
    return t.createElement("div", null, "Something went wrong. Please try again later or contact IPC help desk.");
  }, e.Input = he, e.Label = ge, e.Loading = function () {
    return g.createElement("div", null, "Loading data ...");
  }, e.Login = function (e) {
    var r = ve(t.useState(""), 2),
        n = r[0],
        o = r[1],
        i = ve(t.useState(""), 2),
        a = i[0],
        l = i[1],
        u = e.login,
        c = e.errorMessage;
    return g.createElement(Te, {
      onSubmit: function onSubmit(e) {
        e.preventDefault(), u(n, a);
      }
    }, g.createElement(Fe, null, "Login"), g.createElement(_e, {
      name: "username",
      label: "Username",
      value: n,
      autoComplete: "username",
      onChange: Ne(o),
      autoFocus: !0
    }), g.createElement(De, {
      name: "password",
      label: "Password",
      value: a,
      type: "password",
      autoComplete: "current-password",
      onChange: Ne(l)
    }), g.createElement(Re, null, g.createElement(Be, null, c), g.createElement(Ie, {
      disabled: !(Ce(n) && Ce(a))
    }, "Login")));
  }, e.MultiSelect = Le, e.MultiSelectOption = qe, e.NotificationProvider = Fn, e.Notifications = function () {
    var e = ve(Bn(), 2),
        r = e[0],
        n = e[1],
        o = n.removeNotification,
        i = n.closeNotification,
        a = new jn(r),
        l = ve([Gn, function (e) {
      Gn = e;
    }], 2),
        u = l[0],
        c = l[1],
        s = function s(e) {
      var t,
          r,
          n = e.id;
      o({
        id: n
      }), t = n, (r = Vn(u)).splice(r.indexOf(t), 1), c(r);
    },
        d = function d(e) {
      var t = e.id;
      a.has(t) && !a.find(t).isClosing && (i({
        id: t
      }), setTimeout(function () {
        return s({
          id: t
        });
      }, 1e3));
    },
        p = function p(e) {
      if (-1 === u.indexOf(e.id)) {
        var t = [].concat(Vn(u), [e.id]);
        c(t), r = {
          id: e.id,
          delay: 1e3 * e.duration - 1e3
        }, n = r.id, o = r.delay, setTimeout(function () {
          return d({
            id: n
          });
        }, o);
      }

      var r, n, o;
    };

    return t.useEffect(function () {
      a.loop(function (e) {
        e.duration && p(e);
      });
    }), g.createElement(Yn, null, a.map(function (e) {
      return g.createElement(Mn, Object.assign({
        key: e.id
      }, e, {
        onClose: d
      }));
    }));
  }, e.NotificationsAdapter = Kn, e.Panel = function (e) {
    var r = e.title,
        n = e.children,
        o = e.expanded,
        i = void 0 !== o && o,
        a = T(e, ["title", "children", "expanded"]),
        l = ve(t.useState(i), 2),
        u = l[0],
        c = l[1];
    return g.createElement(ut, a, g.createElement(ct, {
      expanded: u
    }, g.createElement(dt, null, r), g.createElement(ft, null, u && g.createElement(mt, {
      onClick: function onClick() {
        return c(!1);
      }
    }, g.createElement(bt, {
      icon: ze
    })), !u && g.createElement(ht, {
      onClick: function onClick() {
        return c(!0);
      }
    }, g.createElement(bt, {
      icon: Ue
    })))), g.createElement(st, null, n && u && g.createElement(pt, null, n)));
  }, e.RadioButton = kt, e.RadioButtonGroup = d, e.Select = function (e) {
    return g.createElement(u, e);
  }, e.SelectOption = Ve, e.Table = function (e) {
    return g.createElement(Rt, e);
  }, e.columns = function (e) {
    var t = function (e) {
      return {
        applyNumberFilter: f.bind(Zr, null, f, e),
        applyFloatFilter: f.bind(Xr, null, f, e),
        applyTextFilter: f.bind(Yr, null, f, e),
        applyDateFilter: f.bind($r, null, f, e),
        applyDatetimeFilter: f.bind(en, null, f, e),
        applyBooleanFilter: f.bind(Kr, null, f, e),
        applySelectFilter: Jr
      };
    }(e),
        r = function (e) {
      function r(e, n, o) {
        var i;
        return W(this, r), (i = K(this, J(r).call(this, e, n, o))).Cell = an("boolean"), Object.assign(Y(i), t.applyBooleanFilter(Y(i))), i;
      }

      return X(r, e), r;
    }(At),
        n = function (e) {
      function r(e, n, o) {
        var i;
        return W(this, r), i = K(this, J(r).call(this, e, n, o)), Object.assign(Y(i), t.applyDateFilter(Y(i))), i.Cell = an("date"), i;
      }

      return X(r, e), r;
    }(At),
        o = function (e) {
      function r(e, n, o) {
        var i;
        return W(this, r), i = K(this, J(r).call(this, e, n, o)), Object.assign(Y(i), t.applyDatetimeFilter(Y(i))), i.Cell = an("dateTime"), i;
      }

      return X(r, e), r;
    }(At),
        i = function (e) {
      function r(e, n, o) {
        var i;
        return W(this, r), i = K(this, J(r).call(this, e, n, o)), Object.assign(Y(i), t.applyTextFilter(Y(i))), i;
      }

      return X(r, e), r;
    }(At),
        a = function (e) {
      function r(e, n, o) {
        var i;
        return W(this, r), i = K(this, J(r).call(this, e, n, o)), Object.assign(Y(i), t.applyTextFilter(Y(i))), i.Cell = an("multiline"), i;
      }

      return X(r, e), r;
    }(At),
        l = function (e) {
      function r(e, n, o) {
        var i;
        return W(this, r), i = K(this, J(r).call(this, e, n, o)), Object.assign(Y(i), t.applyTextFilter(Y(i))), i.Cell = an("duration"), i;
      }

      return X(r, e), r;
    }(At),
        u = function (e) {
      function r(e, n, o) {
        var i;
        return W(this, r), i = K(this, J(r).call(this, e, n, o)), Object.assign(Y(i), t.applyNumberFilter(Y(i))), i.sortMethod = It, i.className = "-column-align-right", i;
      }

      return X(r, e), r;
    }(At),
        c = function (e) {
      function t(e, r, n) {
        var o;
        return W(this, t), (o = K(this, J(t).call(this, e, r, n))).Cell = an("nonZeroNumber"), o;
      }

      return X(t, e), t;
    }(u);

    return {
      BooleanColumn: r,
      DateTimeColumn: o,
      DateColumn: n,
      FloatColumn: function (e) {
        function r(e, n, o) {
          var i;
          return W(this, r), i = K(this, J(r).call(this, e, n, o)), Object.assign(Y(i), t.applyFloatFilter(Y(i))), i.sortMethod = It, i.Cell = an("float"), i.className = "-column-align-right", i;
        }

        return X(r, e), r;
      }(At),
      TextColumn: i,
      MultilineColumn: a,
      DurationColumn: l,
      NumberColumn: u,
      PercentageColumn: function (e) {
        function r(e, n, o) {
          var i;
          return W(this, r), i = K(this, J(r).call(this, e, n, o)), Object.assign(Y(i), t.applyNumberFilter(Y(i))), i.Cell = an("percentage"), i.sortMethod = It, i.className = "-column-align-right", i;
        }

        return X(r, e), r;
      }(At),
      NonZeroNumberColumn: c,
      NonZeroPercentageColumn: function (e) {
        function t(e, r, n) {
          var o;
          return W(this, t), (o = K(this, J(t).call(this, e, r, n))).Cell = an("nonZeroPercentage"), o;
        }

        return X(t, e), t;
      }(u),
      ContainerColumn: Bt
    };
  }, e.useNotification = In, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});